import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Checkbox,
  AutocompleteRenderInputParams,
} from "@mui/material";
import {
  saveOrEditTaskMapping,
} from "../../Service/AxiosService";
import { Autocomplete } from "@mui/material";

const priorities = [
  { value: "Low", label: "Low" },
  { value: "Normal", label: "Normal" },
  { value: "High", label: "High" },
];

const AddTask = (props: {
  open: boolean;
  onClose: () => void;
  providerList: { id: string; name: string }[];
  tagList: { id: string; name: string }[];
  initialvalues?: any;
  customFields?: { fieldId: string; fieldName: string }[];
  DueDate?: string;
}): React.ReactElement => {
  const [form, setForm] = useState({
    GHLTagName: "",
    TaskSubject: "",
    TaskDetails: "",
    provider: "",
    AssignTo: "",
    customFields: "",
    customFieldValue: "",
    hasValue: false,
    Priority: "Medium",
    DueDate: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const [enableTagCondition, setEnableTagCondition] = useState(false);

  const isFormValid = true;
  useEffect(() => {
    if (props.initialvalues) {
      setForm({
        GHLTagName:
          props.tagList.find(
            (tag) => tag.name === props.initialvalues.GHLTagName,
          )?.id || "",
        TaskSubject: props.initialvalues.TaskSubject || "",
        TaskDetails: props.initialvalues.TaskDetails || "",
        provider:
          props.providerList.find(
            (provider) => provider.name === props.initialvalues.CerboId,
          )?.id || "",
        AssignTo: "",
        Priority: props.initialvalues.Priority || "Normal",
        customFields:
          props.customFields?.find(
            (field) => field.fieldName === props.initialvalues.customFieldId,
          )?.fieldId || "",
        customFieldValue: props.initialvalues.customFieldValue || "",
        hasValue: props.initialvalues.HasValue === "Enabled" ? true : false,
        DueDate: props.initialvalues.DueDate || "",
      });
      setEnableTagCondition(
        props.initialvalues.HasValue === "Enabled" ? true : false,
      );
    } else {
      setForm({
        GHLTagName: "",
        TaskSubject: "",
        TaskDetails: "",
        provider: "",
        AssignTo: "",
        Priority: "Medium",
        customFields: "",
        customFieldValue: "",
        hasValue: false,
        DueDate: "",
      });
      setEnableTagCondition(false);
    }
  }, [props.initialvalues]);

  const handleChange = (field: string, value: any) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => {
    setForm({
      GHLTagName: "",
      TaskSubject: "",
      TaskDetails: "",
      provider: "",
      AssignTo: "",
      Priority: "Medium",
      customFields: "",
      customFieldValue: "",
      hasValue: false,
      DueDate: "",
    });
    setError(null);
    setValidationErrors({});
    props.onClose();
  };

  const handleSubmit = async () => {
    const payload = {
      id: props.initialvalues ? props.initialvalues.id : undefined,
      campaignTagId: form.GHLTagName || "",
      cerboTaskSubject: form.TaskSubject || "",
      taskDetails: form.TaskDetails || "",
      cerboDoctorId: Number(form.provider) || 0,
      cerboPriority: form.Priority || "",
      assignTo: form.AssignTo || "",
      dueDate: form.DueDate || "",
      createddateTime: new Date().toISOString(),
      updatedDateTime: new Date().toISOString(),
      isAddCerbo: true,
      hasValue: enableTagCondition,
      customFieldId: form.customFields || "",
      customFieldValue: form.customFieldValue || ""
    };

    console.log("Payload:", payload);
    await saveOrEditTaskMapping(payload);
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: "#FAFAFC",
          boxShadow: "0 2px 16px rgba(24,26,42,0.10)",
          minWidth: 320,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Configure Task Rule</DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, sm: 3 },
          maxHeight: "80vh",
          overflowY: "auto",
          minHeight: 0,
          background: "#FAFAFC",
        }}
      >
        <Box sx={{ width: "100%" }}>
          {/* Step 1: GHL Tag Name */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">1</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  HL Tag Name
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enter the HL tag name that will trigger this task rule.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <Autocomplete
                    options={props.tagList}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.tagList.find((tag) => tag.id === form.GHLTagName) ||
                      undefined
                    }
                    onChange={(_, newValue) => {
                      handleChange("GHLTagName", newValue ? newValue.id : "");
                      if (validationErrors.GHLTagName) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          GHLTagName: "",
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="HL Tag Name"
                        size="small"
                        fullWidth
                        variant="outlined"
                        error={!!validationErrors.GHLTagName}
                        helperText={validationErrors.GHLTagName}
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "100%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                  {validationErrors.GHLTagName && (
                    <Typography sx={{ color: "red", fontSize: 12, mt: 1 }}>
                      {validationErrors.GHLTagName}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Step 2: Task Subject */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">2</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Task Subject
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Provide a subject for the task that will be created.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <TextField
                    label="Task Subject"
                    value={form.TaskSubject}
                    onChange={(e) => {
                      handleChange("TaskSubject", e.target.value);
                      if (validationErrors.TaskSubject) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          TaskSubject: "",
                        }));
                      }
                    }}
                    fullWidth
                    error={!!validationErrors.TaskSubject}
                    helperText={validationErrors.TaskSubject}
                    size="small"
                    variant="outlined"
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                      "& .MuiOutlinedInput-root": {
                        fontSize: 14,
                        color: "#23244A",
                        borderRadius: 2,
                        "& fieldset": {
                          borderColor: "#dedede",
                        },
                        "&:hover fieldset": {
                          borderColor: "#3D52A0",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3D52A0",
                        },
                      },

                      "& .MuiInputLabel-root": {
                        fontSize: 13,
                        color: "#23244A",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Step 3: Task Details */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">3</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Task Details
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Add additional details or notes for the task.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <TextField
                    label="Task Details"
                    value={form.TaskDetails}
                    onChange={(e) =>
                      handleChange("TaskDetails", e.target.value)
                    }
                    fullWidth
                    multiline
                    minRows={3}
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                      "& .MuiOutlinedInput-root": {
                        fontSize: 14,
                        color: "#23244A",
                        borderRadius: 2,
                        "& fieldset": {
                          borderColor: "#dedede",
                        },
                        "&:hover fieldset": {
                          borderColor: "#3D52A0",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3D52A0",
                        },
                      },

                      "& .MuiInputLabel-root": {
                        fontSize: 13,
                        color: "#23244A",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Step 4: provider Assignment */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">4</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Assign provider <span style={{ fontWeight: 600, color: '#888' }}>(Optional)</span>
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Select the provider responsible for this task.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <Autocomplete
                    options={props.providerList}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.providerList.find(
                        (doc) => doc.id === form.provider,
                      ) || undefined
                    }
                    onChange={(_, newValue) => {
                      handleChange("provider", newValue ? newValue.id : "");
                      if (validationErrors.provider) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          provider: "",
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Provider"
                        size="small"
                        fullWidth
                        variant="outlined"
                        error={!!validationErrors.provider}
                        helperText={validationErrors.provider}
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "100%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                  {validationErrors.provider && (
                    <Typography sx={{ color: "red", fontSize: 12, mt: 1 }}>
                      {validationErrors.provider}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">5</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Grid direction='row' container alignItems="center" gap={0.5}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 14 }}
                  >
                    Custom Fields
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 13, color: "#555" }}
                  >
                    (Optional)
                  </Typography>
                </Grid>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enable custom fields based on specific conditions.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <FormControlLabel
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: 13,
                        color: "#475569",
                      },
                    }}
                    control={
                      <Checkbox
                        checked={enableTagCondition}
                        style={{ marginRight: 2 }}
                        onChange={(e) =>
                          setEnableTagCondition(e.target.checked)
                        }
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 18,
                          },
                          color: "#94a3b8",
                        }}
                      />
                    }
                    label="Enable Custom Fields"
                  />
                </Grid>
                {enableTagCondition && (
                  <Grid container spacing={2} direction="row">
                    <Grid size={6}>
                      <Autocomplete
                        fullWidth
                        options={props.customFields || []}
                        getOptionLabel={(option) => option.fieldName}
                        slotProps={{
                          paper: {
                            sx: {
                              "& .MuiAutocomplete-option": {
                                fontSize: 13,
                                minHeight: 32,
                              },
                            },
                          },
                        }}
                        value={
                          props.customFields?.find((f: any) =>
                            form.customFields.includes(f.fieldId),
                          ) || undefined
                        }
                        onChange={(_, newValue) =>
                          handleChange("customFields", newValue?.fieldId)
                        }
                        renderInput={function (
                          params: AutocompleteRenderInputParams,
                        ): React.ReactNode {
                          return (
                            <TextField
                              {...params}
                              fullWidth
                              label="Select Custom Fields"
                              placeholder="Select Custom Fields"
                              size="small"
                              variant="outlined"
                              sx={{
                                bgcolor: "#fff",
                                borderRadius: 2,
                                "& .MuiOutlinedInput-root": {
                                  fontSize: 14,
                                  color: "#23244A",
                                  borderRadius: 2,
                                  "& fieldset": {
                                    borderColor: "#dedede",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                },

                                "& .MuiInputLabel-root": {
                                  fontSize: 13,
                                  color: "#23244A",
                                },
                              }}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid size={6}>
                      <TextField
                        label="Custom Field Value"
                        placeholder="Enter custom field value"
                        value={form.customFieldValue}
                        onChange={(e) => handleChange("customFieldValue", e.target.value)}
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">6</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Grid direction='row' container alignItems="center" gap={0.5}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 14 }}
                  >
                    Due Date
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 13, color: "#555" }}
                  >
                    (Optional)
                  </Typography>
                </Grid>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enter the number of days after task creation when this task will be due.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <TextField
                    label="Due in (days)"
                    placeholder="Due in (days)"
                    value={form.DueDate}
                    onChange={(e) => handleChange("DueDate", e.target.value)}
                    sx={{
                      width: 200,
                      bgcolor: "#fff",
                      borderRadius: 3,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: 3,
                        fontSize: 16,
                        height: 48,
                        color: '#23244A',
                        '&.Mui-focused fieldset': {
                          borderColor: '#3D52A0',
                        },
                        '& fieldset': {
                          borderColor: '#dedede',
                        },
                        '&:hover fieldset': {
                          borderColor: '#3D52A0',
                        },
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        fontSize: 16,
                        color: '#23244A',
                        left: 8,
                        top: 2,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Step 6: Priority */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">7</Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Priority
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Set the priority level for this task.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mb: 3, ml: 3 }}
              >
                <Grid>
                  <FormControl
                    component="fieldset"
                    error={!!validationErrors.Priority}
                  >
                    <RadioGroup
                      row
                      value={form.Priority}
                      onChange={(e) => {
                        handleChange("Priority", e.target.value);
                        if (validationErrors.Priority) {
                          setValidationErrors((prev) => ({
                            ...prev,
                            Priority: "",
                          }));
                        }
                      }}
                      sx={{
                        borderRadius: 2,
                        p: 1,
                        background: "#fff",
                        justifyContent: "left",
                        gap: 3,
                        ml: 3,
                      }}
                    >
                      {priorities.map((p) => (
                        <FormControlLabel
                          key={p.value}
                          value={p.value}
                          control={<Radio size="small"
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18,
                              },
                              color: '#94a3b8',
                            }} />}
                          label={p.label}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: 13,
                              color: "#475569",
                            },
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  {validationErrors.Priority && (
                    <Typography sx={{ color: "red", fontSize: 12, mt: 1 }}>
                      {validationErrors.Priority}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 2, background: "#FAFAFC" }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            minWidth: 110,
            border: "none",
            background: "#dedede",
            color: "#000",
            textTransform: "capitalize",
            "&:hover": { background: "#d6d6d6" },
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!isFormValid}
          onClick={handleSubmit}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            minWidth: 160,
            background: "#1eac53",
            textTransform: "capitalize",
            "&:hover": { background: "#1a9849" },
          }}
        >
          {"Save & Continue"}
        </Button>
      </DialogActions>
      {error && (
        <Box
          sx={{
            color: "#d32f2f",
            textAlign: "center",
            pb: 2,
            px: 3,
            fontWeight: 500,
          }}
        >
          {error}
        </Box>
      )}
    </Dialog>
  );
};

export default AddTask;
